import * as React from 'react';

import cx from 'classnames';

interface Props {
  children: React.ReactNode;
  score?: number;
  showResult?: boolean;
  isCorrect?: boolean;
  hasCorrectAnswer?: boolean;
  disableInitialBg?: boolean;
}

export function ResultsQuestionAnswerResult({
  children,
  score,
  showResult,
  isCorrect,
  hasCorrectAnswer,
  disableInitialBg,
}: Props): React.ReactElement {
  const containerClass = cx(
    'relative flex flex-1 justify-between w-full rounded-1',
    'ease-out-snap duration-500',
    disableInitialBg ? [showResult && 'px-4', 'py-2'] : 'px-4 py-2',
    showResult && hasCorrectAnswer && isCorrect && 'bg-green-50',
    showResult && hasCorrectAnswer && !isCorrect && 'bg-red-100 delay-300',
    disableInitialBg ? (showResult ? 'bg-grey-50' : '') : 'bg-grey-50'
  );
  const fillClass = cx(
    'absolute top-0 left-0 w-full h-full pointer-events-none',
    'transition ease-out-snap origin-left',
    hasCorrectAnswer && isCorrect && 'bg-green-200 duration-500',
    hasCorrectAnswer && !isCorrect && 'bg-red-300 duration-300',
    !hasCorrectAnswer && 'bg-grey-300 duration-300',
    !isCorrect && showResult ? 'delay-300' : ''
  );
  const textClass = cx(
    'font-sans text-sm leading-8',
    hasCorrectAnswer && showResult
      ? isCorrect
        ? 'text-green-900'
        : 'text-red-900'
      : 'text-blue-900'
  );
  const scoreClass = cx(
    'absolute top-0 right-0 mt-2 mr-4 transition ease-out-snap duration-700',
    showResult ? 'opacity-100' : 'opacity-0'
  );

  return (
    <div
      className={containerClass}
      style={{ transitionProperty: 'padding, background-color' }}
    >
      <div className="absolute inset-0 overflow-hidden rounded-1">
        <div
          className={fillClass}
          style={{ transform: `scaleX(${showResult ? score / 100 : 0})` }}
          data-testid="result-answer-fill"
        />
      </div>
      <div className="mr-16 relative">
        <div
          className={textClass}
          style={{ wordBreak: 'break-word', overflowWrap: 'anywhere' }}
        >
          {children}
        </div>
      </div>
      <div className={scoreClass}>
        <span className={`${textClass} font-500`}>{score}%</span>
      </div>
    </div>
  );
}
